import React, { Component, PropTypes } from 'react';
import FunVideoRemote from './funVideoRemote';
import './fun.scss';

export default class Fun extends Component {

  static contextTypes = {
    presenter: PropTypes.bool,
    program: PropTypes.object.isRequired,
    session: PropTypes.object.isRequired,
    setVideoState: PropTypes.func.isRequired,
    setMode: PropTypes.func.isRequired,
    regionData: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };

  clickVideo (index, evt) {
    const { setMode, setVideoState } = this.context;
    setVideoState({
      playing: false,
      started: false,
      finished: false
    }).then(() => {
      setMode(`extras/${index}`);
    });
    evt.preventDefault();
    evt.stopPropagation();
    evt.nativeEvent.stopPropagation();
  }

  render () {
    const {
      presenter,
      program: {
        funMd
      },
      session: {
        mode
      },
      regionData,
      i18n: _
    } = this.context;
    const funMd_i18n = _(funMd);
    const funItemNames = funMd_i18n.getSectionNames();
    if (presenter && mode !== 'extras') {
      return <FunVideoRemote />;
    }
    return (
      <div className="fun">
        <h1>{_('Extras')}</h1>
        <ul className="fun-items scroller-panel">
          {funItemNames.map((funItemName, index) => {
            const youTubeId = funMd_i18n.getSectionMetadata(funItemName, 'YouTube', regionData);
            const description = funMd_i18n.getSubSectionAsString(
              funItemName,
              'Description',
              false,
              regionData
            );
            return (
              <li
                  className="fun-item"
                  key={funItemName}>
                <a href="#"
                   onClick={this.clickVideo.bind(this, index + 1)}>
                   <figure className="fun-image">
                     <img
                     src={`//img.youtube.com/vi/${youTubeId}/hqdefault.jpg`} />
                   </figure>
                </a>
                <div className="fun-item-info">
                  <h3>{funItemName}</h3>
                  <p>{description}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/fun/index.jsx